let $ = require('jquery');
let css = require('./collapse.css');
let { cut } = require('../../../../helpers/utils');
let { raiseEvent } = require('../../../../signals/analytics');
let bitrix = require('../../../../signals/bitrix');

const SELECTOR_HEADER = cut(css.headerClickable);
const SELECTOR_COLLAPSED = css.collapsed;
const SELECTOR_WRAPPER = cut(css.wrapper);
const SELECTOR_PANEL = cut(css.panel);
const SELECTOR_CONTENT = cut(css.content);

class Collapse {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, this.$context.props, { css }));
    }

    bind () {
        return {
            click: {
                [SELECTOR_HEADER]: this.onClick
            }
        };
    }

    onClick (e) {
        e.stopPropagation();

        let element = $(this.$context.element);
        let panel = element.find(SELECTOR_PANEL);
        let content = element.find(SELECTOR_CONTENT);
        let wrapper = element.find(SELECTOR_WRAPPER);

        let fullHeight = wrapper.height();

        let isCollapsed = panel.hasClass(SELECTOR_COLLAPSED);
        panel.toggleClass(SELECTOR_COLLAPSED);

        let startHeight = isCollapsed ? 0 : fullHeight;
        let height = isCollapsed ? fullHeight : 0;

        content.css({ overflow: 'hidden', 'max-height': startHeight + 'px' });

        content.animate({ 'max-height': height + 'px' }, 250, () => {
            content.removeAttr('style');
            this.$context.signal(bitrix.resize);
        });

        if (this.$context.props.dontUseMetric !== 'true' && isCollapsed) {
            this.$context.signal(raiseEvent, { category: this.$context.props.metricCategory, action: 'click' });
        }
    }
}

module.exports = Collapse;




// WEBPACK FOOTER //
// ./components/common/custom-order/collapse/index.js